import React, { useEffect } from 'react';

import { ContentBox, ContentsLayout, Main, Meta } from '@layout';
import { KakaoMap } from '@components/kakaomap';

import Image from 'next/image';
import { Fade } from 'react-awesome-reveal';

const contents = {
  title1: '고객센터',
  title2: '고객센터',
  contentsHeaderTitle: '고객센터',
  contentsHeaderDesc: `대기업과 중소기업, 상생 그 이상을 연결하는 세금포인트몰과 지금 함께하세요.`,
  border: true,
};

const Index = () => {
  const kakaoMap = React.useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (kakaoMap && kakaoMap.current) {
      const x = 126.875937;
      const y = 37.52947;
      const coords = new (window as any).daum.maps.LatLng(y, x); // 지도의 중심좌표
      const options = {
        center: coords,
        level: 2,
      };
      const map = new (window as any).daum.maps.Map(kakaoMap.current, options);
      const marker = new (window as any).daum.maps.Marker({
        position: coords,
        map,
      });
      // 맵의 중앙으로 이동
      map.relayout();
      map.setCenter(coords);
      // 마커를 중앙으로 이동
      marker.setPosition(coords);

      // 일반 지도와 스카이뷰로 지도 타입을 전환할 수 있는 지도타입 컨트롤을 생성합니다
      const mapTypeControl = new (window as any).daum.maps.MapTypeControl();

      // 지도에 컨트롤을 추가해야 지도위에 표시됩니다
      // kakao.maps.ControlPosition은 컨트롤이 표시될 위치를 정의하는데 TOPRIGHT는 오른쪽 위를 의미합니다
      map.addControl(mapTypeControl, (window as any).kakao.maps.ControlPosition.TOPRIGHT);
      // 지도 확대 축소를 제어할 수 있는  줌 컨트롤을 생성합니다
      const zoomControl = new (window as any).daum.maps.ZoomControl();
      map.addControl(zoomControl, (window as any).daum.maps.ControlPosition.RIGHT);
    }
  }, [kakaoMap]);

  return (
    <Main
      meta={
        <Meta
          title="고객센터 | 세금포인트 할인쇼핑몰"
          description="대기업과 중소기업, 상생 그 이상을 연결하는 세금포인트몰과 지금 함께하세요."
          canonical="https://www.taxpoint.or.kr"
        />
      }
    >
      <ContentsLayout contents={contents}>
        <ContentBox title="고객센터">
          <li className="flex">
            <div className="flex-1">
              <strong>이메일</strong>
            </div>
            <div className="flex-3 laptop:flex-5">
              중소기업 상품입점 :{' '}
              <a
                href="mailto:yejinpark@sbdc.or.kr?Subject=중소기업%20상품입점%20문의"
                className="text-primary"
              >
                kim123@kodma.or.kr
              </a>
            </div>
          </li>
          <li className="flex">
            <div className="flex-1">
              <strong>전화번호</strong>
            </div>
            <div className="flex-3 laptop:flex-5">
              중소기업 상품입점 :{' '}
              <a href="tel:02-6678-9829" className="text-primary">
                02-6678-9825
              </a>
            </div>
          </li>
          <li className="flex">
            <div className="flex-1">
              <strong>헬프데스크</strong>
            </div>
            <div className="flex-3 laptop:flex-5">
              세금포인트몰 이용관련 문의 :{' '}
              <a href="tel:1522-6009" className="text-primary">
                1522-6009
              </a>
            </div>
          </li>
        </ContentBox>
        <ContentBox title="오시는길">
          <li className="flex">
            <div className="flex-1">
              <strong>주소</strong>
            </div>
            <div className="flex-3 laptop:flex-5">
              서울특별시 양천구 목동동로 309 한국중소벤처기업유통원 3층 온라인지원실 동반성장몰팀
            </div>
          </li>
          <li className="flex">
            <div className="flex-1">
              <strong>지하철</strong>
            </div>
            <div className="flex-3 laptop:flex-5">
              <span className="mr-2 px-2 py-1 text-white text-sm bg-purple-800 rounded-2xl">
                5호선
              </span>
              오목교역 2번출구 방면
            </div>
          </li>
        </ContentBox>

        <KakaoMap ref={kakaoMap} />
        <Fade triggerOnce>
          <div className="flex laptop:hidden justify-center pt-3">
            <Image
              src={`/customer/search_mobile.jpg`}
              alt="세금포인트몰"
              width="720"
              height="241"
            />
          </div>
          <div className="laptop:flex hidden justify-center pt-3">
            <Image
              src={`/customer/search_laptop.jpg`}
              alt="세금포인트몰"
              width="1100"
              height="101"
            />
          </div>
        </Fade>
      </ContentsLayout>
    </Main>
  );
};

export default Index;
